export const THEME = {
  primaryColor: '#4CB258',
  gray: '#515251',
}
